module.exports = __webpack_public_path__ + "static/img/xiaomi.3a416dc0.png";